import {Chip, styled, Avatar, Box} from '../../../ui-library';

export const EmailChip = styled(Chip)`
color: ${({ theme }) => theme.palette.grey[800]};
    background-color: ${({ theme }) => theme.palette.primary.light};
    & .MuiChip-label{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.16px;
        color: ${({ theme }) => theme.palette.grey[900]};
  },
`;

export const ChipAvatar = styled(Avatar)`
background-color: ${({ theme }) => theme.palette.grey[300]};
`;

export const ChipsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    gap:9px;

`;
